/*! @azure/msal-react v2.0.1 2023-08-11 */
'use strict';

import _slicedToArray from "/opt/Talento100/talento100_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { useMsal } from './useMsal.js';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccountByIdentifiers } from '../utils/utilities.js';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

function isAuthenticated(allAccounts, matchAccount) {
  if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) {
    return !!getAccountByIdentifiers(allAccounts, matchAccount);
  }

  return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */


function useIsAuthenticated(matchAccount) {
  var _useMsal = useMsal(),
      allAccounts = _useMsal.accounts,
      inProgress = _useMsal.inProgress;

  var _useState = useState(function () {
    if (inProgress === InteractionStatus.Startup) {
      return false;
    }

    return isAuthenticated(allAccounts, matchAccount);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      hasAuthenticated = _useState2[0],
      setHasAuthenticated = _useState2[1];

  useEffect(function () {
    setHasAuthenticated(isAuthenticated(allAccounts, matchAccount));
  }, [allAccounts, matchAccount]);
  return hasAuthenticated;
}

export { useIsAuthenticated };